var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinetuneParametersAutoTone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 4v2l2.667-2.667L8 .667v2A5.33 5.33 0 0 0 2.667 8c0 1.047.306 2.02.826 2.84l.974-.973A3.9 3.9 0 0 1 4 8c0-2.207 1.793-4 4-4m4.507 1.16-.974.973C11.827 6.693 12 7.327 12 8c0 2.207-1.793 4-4 4v-2l-2.667 2.667L8 15.333v-2A5.33 5.33 0 0 0 13.333 8c0-1.047-.306-2.02-.826-2.84"
})));
export default SvgFinetuneParametersAutoTone;